"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgProCircle(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("g", {
    fill: "inherit",
    fillRule: "evenodd"
  }, React.createElement("path", {
    d: "M18.668 7.429c.313 0 .57.256.57.571v7.619a.572.572 0 01-.57.571H5.713a.572.572 0 01-.57-.571V8c0-.314.255-.571.57-.571zm-3.21 2.666c-1.076 0-1.884.768-1.884 1.715v.009c0 .947.798 1.705 1.875 1.705s1.884-.768 1.884-1.714c0-.956-.797-1.715-1.875-1.715zm-3.552.066h-1.65v3.297h.967v-.999h.424l.703.999h1.117l-.833-1.15c.434-.174.718-.508.718-1.012 0-.334-.105-.589-.309-.777-.234-.226-.603-.358-1.137-.358zm-3.363 0H7.048v3.297h.967v-.942h.479c.867 0 1.5-.41 1.5-1.187 0-.74-.568-1.168-1.45-1.168z"
  }), React.createElement("path", {
    d: "M14.566 11.81c0 .475.364.89.892.89a.864.864 0 00.888-.881v-.01a.88.88 0 00-.897-.89.863.863 0 00-.883.881v.01zM11.223 10.952v.792h.639c.328 0 .518-.151.518-.391v-.01c0-.259-.2-.39-.524-.39h-.633zM8.015 10.929v.871h.459c.344 0 .553-.17.553-.428v-.01c0-.282-.21-.433-.558-.433h-.454z"
  }), React.createElement("path", {
    d: "M12 0C5.372 0 0 5.373 0 12c0 6.628 5.372 12 12 12 6.627 0 12-5.372 12-12 0-6.626-5.374-12-12-12zm0 1.532c5.78 0 10.468 4.688 10.468 10.468 0 5.782-4.687 10.468-10.468 10.468-5.782 0-10.468-4.686-10.468-10.468C1.532 6.22 6.218 1.532 12 1.532z",
    fillRule: "nonzero"
  })));
}

var _default = SvgProCircle;
exports.default = _default;